import { render, staticRenderFns } from "./projectComplaint.vue?vue&type=template&id=2f620191&scoped=true"
import script from "./projectComplaint.vue?vue&type=script&lang=js"
export * from "./projectComplaint.vue?vue&type=script&lang=js"
import style0 from "./projectComplaint.vue?vue&type=style&index=0&id=2f620191&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f620191",
  null
  
)

export default component.exports